var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 text grey--text text--darken-1",
    class: _vm.titleClassSize
  }, [_vm._v(" Our commitment as the Acapedia community ")]), _c('h3', {
    staticClass: "heading primary--text",
    class: _vm.smallMobileSize ? 'heading-m-small' : 'heading-m-large'
  }, [_vm._v(" Professional Integrity ")])])], 1), _c('v-row', {
    staticClass: "margin-top-body",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      staticClass: "panel pa-2 pa-sm-4",
      attrs: {
        "index": index,
        "cols": "12",
        "sm": "4"
      }
    }, [index === 0 ? _c('ph-scroll', {
      attrs: {
        "weight": "thin",
        "size": _vm.sizeForIcon,
        "color": "var(--v-secondary-base)"
      }
    }) : _vm._e(), index === 1 ? _c('ph-handshake', {
      attrs: {
        "weight": "thin",
        "size": _vm.sizeForIcon,
        "color": "var(--v-secondary-base)"
      }
    }) : _vm._e(), index === 2 ? _c('ph-circle-wavy-warning', {
      attrs: {
        "weight": "thin",
        "size": _vm.sizeForIcon,
        "color": "var(--v-secondary-base)"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "panel-container"
    }, [_c('h3', {
      staticClass: "text grey--text text-l-large-bold text--darken-1 mb-1",
      class: _vm.smallMobileSize ? 'text-m-large-bold' : 'text-l-large-bold'
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('h3', {
      staticClass: "text grey--text text--darken-4 mb-0",
      class: _vm.smallMobileSize ? 'text-m-large-regular' : 'text-l-large-regular'
    }, [_vm._v(" " + _vm._s(item.text) + " ")])])], 1);
  }), 1), _c('v-row', {
    staticClass: "btn-container mt-sm-6",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "heading heading-s-small align-self-center unaltered-text-cap shadow-light-button px-6",
    attrs: {
      "ripple": "",
      "depressed": "",
      "block": _vm.mobileSize || _vm.smallMobileSize,
      "height": _vm.mobileSize || _vm.smallMobileSize ? '44px' : '36px',
      "color": "primary white--text"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(" Continue ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }